import { useEffect, useState } from "react";
import { spinnerStore } from "../Stores/SpinnerStore/SpinnerStore";

export const Spinner = () => {
  const [spin, setSpin] = useState(spinnerStore.getState());

  useEffect(() => {
    const unsubscribe = spinnerStore.subscribe((isActive, activeCount) => {
      setSpin(isActive);
      // console.log(activeCount)
    });
    return () => unsubscribe();
  }, []);

  if (!spin) return null;

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed",
        width: "100vw",
        height: "100vh",
        background: "#00000080",
        zIndex: 99999,
        top: 0,
        left: 0,
        color: "white",
        fontSize: "18px",
        flexDirection: "column",
      }}
    >
      <div id="status">
        <div role="status">
          <span className="__loader"></span>
        </div>
      </div>
    </div>
  );
};

